import PropTypes from 'prop-types';
// import { useState } from 'react';

import { useTheme } from '@mui/material/styles';
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

// import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
// import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined';
// import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';

const ProfileTab = ({ handleLogout }) => {
    const theme = useTheme();

    // const [selectedIndex, setSelectedIndex] = useState(0);
    // const handleListItemClick = (event, index) => {
    //     setSelectedIndex(index);
    // };

    return (
        <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32, color: theme.palette.grey[500] } }}>
            {/* <ListItemButton selected={selectedIndex === 0} onClick={(event) => handleListItemClick(event, 0)}>
                <ListItemIcon>
                    <BorderColorOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary="Editar Perfil" />
            </ListItemButton>
            <ListItemButton selected={selectedIndex === 1} onClick={(event) => handleListItemClick(event, 1)}>
                <ListItemIcon>
                    <PermIdentityOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary="Ver Perfil" />
            </ListItemButton>
            <ListItemButton selected={selectedIndex === 2} onClick={(event) => handleListItemClick(event, 2)}>
                <ListItemIcon>
                    <AccountBalanceWalletOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary="Billing" />
            </ListItemButton> */}
            <ListItemButton
                // selected={selectedIndex === 3}
                onClick={handleLogout}
            >
                <ListItemIcon>
                    <LogoutOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary="Logout" />
            </ListItemButton>
        </List>
    );
};

ProfileTab.propTypes = {
    handleLogout: PropTypes.func
};

export default ProfileTab;
